import cn from "classnames";

export type GetBemBlocksWith = (elementOrModifier?: string) => string;

export type CreateBemBlockBuilder = (
  blocks: (string | undefined)[],
) => GetBemBlocksWith;

export const createBemBlockBuilder: CreateBemBlockBuilder = (blocks) => {
  const cleanedBlocks = blocks.reduce(
    (reviewedBlocks, block) =>
      block ? reviewedBlocks.concat(block.trim().split(" ")) : reviewedBlocks,
    [] as string[],
  );

  return (elementOrModifier = "") =>
    cleanedBlocks.reduce(
      (classList, block) => cn(classList, `${block}${elementOrModifier}`),
      "",
    );
};
